<template>
  <div>
    <Top/>
    <div class="cght_htmainbox cght_htmainboxnobg">
      <div class="cght_htmain cgw1216">
        <div v-show="current_user.MAccountRole !== 3">
        <div class="cght_tjddtitle">填写并核对订单信息</div>
        <div class="cght_tjddtitle2">
          <div>
            <a href="javascript:;" class="cght_shdttcxgxjs" @click="showDialog()">新增收货地址</a>
            <router-link :to="{path:'/Address'}">管理收货地址</router-link>
          </div>
          收货人信息
        </div>
        <ul class="cght_tjddullis" :style="openType=='ZK'?'height:240px;':'height:120px;'">
          <li class="cght_shdzwmrdzd" v-for="(item,index) in addressList" :key="index" :class="item.checkTrue?'cght_tjddullis_li':''" @click="selectAddress(index)">
            <div style="overflow: hidden;padding: 0 21px 0 10px;border-bottom: 1px solid #f2f2f2;">
              <div class="cght_tjddullis3 cght_shdzw3" style="float: right;width: 100px;text-align: left;color: #666;">{{item.tel}}</div>
              <div class="cght_tjddullis1 cght_shdzw1" style="padding: 0px;border-bottom:none;overflow: hidden;clear: none;white-space: nowrap;text-overflow: ellipsis;width:auto;">{{item.name}}</div>
            </div>
            <div class="cght_tjddullis2 cght_shdzw2 order_title">{{item.province}}-{{item.city}}-{{item.district}}-{{item.address_detail}}</div>
            <div class="cght_tjddullis3">
              <a class="cght_shdttcxgxj" href="javascript:;" @click="showDialog(item)">修改</a>
            </div>
          </li>
        </ul>
        <div class="cght_tjddulliskz">
          <div>
            <em @click="openAddress('ZK')" v-if="!openType && addressList.length > 5">展开</em>
            <span @click="openAddress('')" v-else-if="openType && addressList.length > 5">收起</span>
          </div>
        </div>
        </div>
        <div class="cght_tjddqr"><em><router-link :to="{path:'/Cart'}">返回购物车修改</router-link></em>确认订单信息</div>
        <div class="cght_tjddqrxx" id="printCons">
          <ul class="cght_tjddqrxxr">
            <li v-for="(item,index) in cartGoodsList" :key="index">
              <div class="cght_tjddqrxxr1">
                <router-link :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">
                  <img width="100" height="100" v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.title"/>
                </router-link>
              </div>
              <div class="cght_tjddqrxxr2">
                <h3><router-link  class="order_title" :to="{path:'/GoodsDetail',query:{id:item.goods_id}}" target="_blank" :title="item.title">{{item.title}}</router-link></h3>
                <div class="cght_gwcdtop3b" style="width:100%;">
                  <!-- <el-tag
                    v-for="it in item.specParamList"
                    size="mini"
                    :key="it.id"
                    style="margin-right:6px"
                    effect="plain">
                    {{ it.param_name }}：{{it.option_value}}
                  </el-tag> -->
                  <div v-for="it in item.specParamList" :key="it.id" style="float:left;margin-left:10px;display:inline-block;">
                    {{ it.param_name }}: {{it.option_value}}
                  </div>
                </div>
              </div>
              <div class="cght_tjddqrxxr3" id="print2" style="width:245px;" v-if="item.tax_price && item.tax_price > 0">￥{{item.tax_price}}
                <div class="leaveMessage">
                  <el-tag
                    v-for="it in item.leaveMessage"
                    size="mini"
                    :key="it.id"
                    style="margin-right:6px"
                    effect="plain">
                    {{ it.name }}:{{it.value}}
                  </el-tag>
                </div>
              </div>
              <div class="cght_tjddqrxxr3" style="width:245px;" v-else>询价</div>
              <div class="cght_tjddqrxxr4" id="print3">
                x{{item.number}}
                <div>{{ item.plant_sku || item.sku }}</div>
              </div>
              <div class="cght_tjddqrxxr4" id="print4" v-if="item.tax_price && item.tax_price > 0" style="width:165px;">小计：￥{{(item.tax_price*item.number).toFixed(2)}}</div>
              <div class="cght_tjddqrxxr4" v-else style="width:165px;">询价</div>
              <div class="cght_tjddqrxxr4" v-if="preorderList" style="width:165px">申购人：{{item.premember_name}}</div>
              <div class="cght_tjddqrxxr5" id="print5" v-if="item.delivery_time">{{item.delivery_time}}个工作日内发货</div>
              <div class="cght_tjddqrxxr5" id="print6" v-else>当天可发货</div>
            </li>
          </ul>
        </div>
        <div class="cght_tjddtjbz">添加备注</div>
        <div class="cght_tjddtjbzin">
          <div class="cght_tjddtjbzinl">
            <!-- <input class="cght_inputtextsh" type="text" value="限100个字（定制类商品，请将购买需求在备注中做详细说明）" maxlength="100"/> -->
            <el-input
              type="textarea"
              :rows="2"
              maxlength="160"
              placeholder="请输入内容"
              v-model="remark">
            </el-input>
          </div>
          <!-- <div class="cght_tjddtjbzinr">提示：请勿填写有关支付、收货、发票方面的信息</div> -->
          <el-button type="primary" icon="el-icon-download" size="small" @click="goPrint">打印</el-button>
        </div>
        <div class="cght_tjddfpxxbox">
          <div class="cght_tjddqr">发票信息</div>
          <div class="cght_tjddfpxxa">
            <em class="cght_tjddfpxxaa" :class="invoice===1?'cght_tjddfpxxa_em':''" @click="changeInvoice(1)">增值税专用发票</em>
            <em class="cght_tjddfpxxaa" :class="invoice===2?'cght_tjddfpxxa_em':''" @click="changeInvoice(2)">增值税普通发票</em>
            <em class="cght_tjddfpxxab" :class="invoice===0?'cght_tjddfpxxa_em':''" @click="changeInvoice(0)">暂不开发票</em>
          </div>
          <div v-if="invoice > 0" style="background: #f7f8fa;">
            <div class="cght_tjddfpxxb">
              <a class="cght_tjddfpxxbzzs" v-if="invoice === 1" href="javascript:;" @click="showDialogs(invoice)">新增增值税专用发票</a>
              <a class="cght_tjddfpxxbzzs" v-if="invoice === 2" href="javascript:;" @click="showDialogs(invoice)">新增增值税普通发票</a>
            </div>
          </div>
          <div v-show="invoice===1 && invoiceForm.unitname" style="background: #f7f8fa;">
            <div class="cght_tjddfpxxb">
              <div>单位名称：</div>
              <em style="width: 300px;">{{ invoiceForm.unitname }}</em>
              <div>开户行及账号：</div>
              <em style="width: 300px;">{{ invoiceForm.bankname }} {{ invoiceForm.bankno }}</em>
              <a style="color: #005ea7;margin-left: 10px;" href="javascript:;" @click="showDialogs(invoice, invoiceForm)">修改</a>
            </div>
            <div class="cght_tjddfpxxb">
              <div>纳税人识别号：</div>
              <em style="width: 300px;">{{ invoiceForm.invoicenumber }}</em>
              <div>地址、电话：</div>
              <em style="width: 300px;">{{ invoiceForm.companyaddress }} {{ invoiceForm.companytel }}</em>
            </div>
          </div>
          <div v-show="invoice===2 && invoiceForms.invoicetitle" style="background: #f7f8fa;">
            <div class="cght_tjddfpxxb">
              <div>发票抬头：</div>
              <em style="width: 300px;">{{ invoiceForms.invoicetitle }}</em>
              <div>纳税人识别号：</div>
              <em style="width: 300px;">{{ invoiceForms.invoicenumber }}</em>
              <a style="color: #005ea7;margin-left: 10px;" href="javascript:;" @click="showDialogs(invoice, invoiceForms)">修改</a>
            </div>
          </div>
          <div class="cght_tjddqr">收票地址<a v-if="checked==false" style="color: #005ea7;margin-left: 10px;font-size: 12px;" href="javascript:;" @click="showDialogs(3)">新增收票地址</a> <el-checkbox v-model="checked" @change="handleChange">同收货地址</el-checkbox></div>
          <div v-show="addressForms.payee" style="background: #f7f8fa;">
            <div class="cght_tjddfpxxb">
              <em style="width: 790px;"><i class="el-icon-place"></i> {{ addressForms.payee }} {{ addressForms.province }}{{ addressForms.city }}{{ addressForms.district }}{{ addressForms.address_detail }} {{ addressForms.tel }}</em>
              <a style="color: #005ea7;margin-left: 10px;" href="javascript:;" @click="showDialogs(3, addressForms)">修改</a>
            </div>
          </div>
        </div>
        <div class="cght_tjddbottom">
          <!-- <div class="qhfs">运费：<label type="{$expressfee}">￥{$expressfee}</label></div> -->
          <div class="cght_tjddbottoma">总计：<em>￥{{totalPrice}}</em></div>
          <div class="cght_tjddbottomd">
            <a href="javascript:void(0);" class="cght_tjddbottomda" @click="orderSubmit(1)" v-if="current_user.contract_type == 1">去支付</a>
            <a href="javascript:void(0);" class="cght_tjddbottomda" @click="orderSubmit(2)" v-if="current_user.contract_type == 2">提交订单</a>
            <a href="javascript:void(0);" class="cght_tjddbottomda" @click="handleDownloads">生成Excel</a>
            <router-link :to="{path:'/Cart'}" class="cght_tjddbottomdb">返回购物车修改</router-link>
          </div>
        </div>
        <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
          <el-form :model="dataForm" ref="dataForm" :rules="rules" label-position="left" label-width="100px" style="width: 600px; margin-left:50px;">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="dataForm.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="district">
              <VDistpicker
                :province="dataForm.province"
                :city="dataForm.city"
                :area="dataForm.district"
                @province="onChangeProvince"
                @city="onChangeCity"
                @area="onChangeArea"
              ></VDistpicker>
            </el-form-item>
            <el-form-item label="详细地址" prop="address_detail">
              <el-input v-model="dataForm.address_detail" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="tel">
              <el-input v-model="dataForm.tel" autocomplete="off" maxlength="11"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveAddress">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="增值税专用发票" :visible.sync="dialogFormVisibles">
          <el-form :model="invoiceForm" ref="dataForm" :rules="invoicerules" label-position="left" label-width="110px" style="width: 500px; margin-left:50px;">
            <el-form-item label="单位名称" prop="unitname">
              <el-input v-model="invoiceForm.unitname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="invoicenumber">
              <el-input v-model="invoiceForm.invoicenumber" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="公司注册地址" prop="companyaddress">
              <el-input v-model="invoiceForm.companyaddress" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="公司注册电话" prop="companytel">
              <el-input v-model="invoiceForm.companytel" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="开户行名称" prop="bankname">
              <el-input v-model="invoiceForm.bankname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="开户行账号" prop="bankno">
              <el-input v-model="invoiceForm.bankno" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisibles = false">取 消</el-button>
            <el-button type="primary" @click="saveAddresss">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="增值税普通发票" :visible.sync="dialogFormVisibless">
          <el-form :model="invoiceForms" ref="dataForm" :rules="invoiceruless" label-position="left" label-width="110px" style="width: 500px; margin-left:50px;">
            <el-form-item label="发票抬头" prop="invoicetitle">
              <el-input v-model="invoiceForms.invoicetitle" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="invoicenumber">
              <el-input v-model="invoiceForms.invoicenumber" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisibless = false">取 消</el-button>
            <el-button type="primary" @click="saveAddresss">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="收票地址" :visible.sync="dialogFormVisiblesss">
          <el-form :model="addressForms" ref="dataForm" :rules="addressrules" label-position="left" label-width="100px" style="width: 600px; margin-left:50px;">
            <el-form-item label="收票人" prop="payee">
              <el-input v-model="addressForms.payee" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="addressForms.tel" autocomplete="off" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="所在地区" prop="district">
              <VDistpicker
                :province="addressForms.province"
                :city="addressForms.city"
                :area="addressForms.district"
                @province="onChangeProvinces"
                @city="onChangeCitys"
                @area="onChangeAreas"
              ></VDistpicker>
            </el-form-item>
            <el-form-item label="详细地址" prop="address_detail">
              <el-input v-model="addressForms.address_detail" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="邮编">
              <el-input v-model="addressForms.postalcode" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="固定电话">
              <el-input v-model="addressForms.telephone" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="地址别名">
              <el-input v-model="addressForms.addressalias" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisiblesss = false">取 消</el-button>
            <el-button type="primary" @click="saveAddresss">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <Bottom/>
  </div>
</template>
<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import { mapGetters } from 'vuex'
import api from '@/api/goods'
import order from '@/api/order'
import ad from '@/api/address'
import VDistpicker from 'v-distpicker'
import print from 'print-js'
import export2Excel from 'js-table2excel'

export default {
  name: 'ConfirmOrder',
  components: { Top, LeftNav, Bottom, VDistpicker },
  data () {
    return {
      invoice: 0,
      addressList: [],
      cartGoodsList: [],
      remark: '',
      buyGoods: '',
      addressId: '',
      subCart: [],
      downloadLoading: false,
      filename: '',
      openType: '',
      dialogFormVisible: false,
      dataForm: {
        id: null,
        name: '',
        province: '',
        district: '',
        city: '',
        tel: '',
        address_detail: '',
        is_default: 0
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        district: [{ required: true, message: '请选择完整的收货地址', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        address_detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      preorderList: [],
      nowBuyGoods: [],
      fastList: [],
      title: '内蒙志鹏',
      dialogFormVisibles: false,
      dialogFormVisibless: false,
      dialogFormVisiblesss: false,
      invoiceForm: {
        id: null,
        unitname: '',
        bankname: '',
        bankno: '',
        invoicenumber: '',
        companyaddress: '',
        companytel: ''
      },
      invoicerules: {
        unitname: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
        bankname: [{ required: true, message: '请输入开户行名称', trigger: 'blur' }],
        bankno: [{ required: true, message: '请输入开户行账号', trigger: 'blur' }],
        invoicenumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
        companyaddress: [{ required: true, message: '请输入公司注册地址', trigger: 'blur' }],
        companytel: [{ required: true, message: '请输入公司注册电话', trigger: 'blur' }]
      },
      invoiceForms: {
        id: null,
        invoicetitle: '',
        invoicenumber: ''
      },
      invoiceruless: {
        invoicetitle: [{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
        invoicenumber: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }]
      },
      addressForms: {
        id: null,
        payee: '',
        tel: '',
        province: '',
        city: '',
        district: '',
        address_detail: '',
        postalcode: '',
        telephone: '',
        addressalias: ''
      },
      addressrules: {
        payee: [{ required: true, message: '请输入收票人', trigger: 'blur' }],
        district: [{ required: true, message: '请选择所在地区', trigger: 'blur' }],
        address_detail: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      checked: false
    }
  },
  computed: {
    ...mapGetters(['current_user']),
    totalPrice () {
      let totalPrice = 0
      this.cartGoodsList.map(res => {
        totalPrice += res.number * res.tax_price
      })
      return totalPrice.toFixed(2)
    }
  },
  mounted () {
    this.getAddressList()
    this.buyGoods = JSON.parse(localStorage.getItem('cart_checkList'))
    this.preorderList = JSON.parse(localStorage.getItem('preorderList'))
    this.nowBuyGoods = JSON.parse(localStorage.getItem('nowBuy_goods'))
    this.fastList = JSON.parse(localStorage.getItem('fastList'))
    // 判断是购物车提交还是合并申购单
    if (this.buyGoods) {
      this.getCartList()
    }
    if (this.preorderList) {
      this.getPreordertList()
    }
    if (this.nowBuyGoods) {
      this.getNowBuyGoods()
    }
    if (this.fastList) {
      this.getFastList()
    }
    if (!this.buyGoods && !this.preorderList && !this.nowBuyGoods && !this.fastList) {
      this.$router.push({path: '/MyOrder'})
    }
  },
  methods: {
    saveAddress (row) {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          ad.saveAddress(this.dataForm).then((response) => {
            this.dialogFormVisible = false
            this.$notify({
              title: '收货地址',
              message: '提交成功',
              type: 'success'
            })
            this.getAddressList()
          })
        }
      })
    },
    showDialog (row) {
      if (!row) { row = {} }
      this.dialogFormVisible = true
      this.dataForm = Object.assign({}, row)
    },
    onChangeProvince (data) {
      this.dataForm.province = data.value
    },
    onChangeCity (data) {
      this.dataForm.city = data.value
    },
    onChangeArea (data) {
      this.dataForm.district = data.value
    },
    getAddressList () {
      ad.getAddressList().then(res => {
        let list = res.items
        list.map(res => {
          if (res.is_default) {
            res.checkTrue = true
            this.addressId = res.id
          } else {
            res.checkTrue = false
          }
        })
        this.addressList = list
      })
    },
    selectAddress (index) {
      this.addressList.map(res => {
        res.checkTrue = false
      })
      this.addressList[index].checkTrue = true
      this.addressId = this.addressList[index].id
    },
    getCartList () {
      api.cartCheckList({cart_id: this.buyGoods}).then(res => {
        // this.subCart = JSON.parse(JSON.stringify(res.items)) // 为了提交时候specParamList不在转义
        let cartList = res.items
        cartList.map(res => {
          if (res.leaveMessage) {
            res.leaveMessage = JSON.parse(res.leaveMessage)
          }
          if (res.specParamList) {
            res.specParamList = JSON.parse(res.specParamList)
          }
        })
        this.cartGoodsList = cartList
      })
    },
    getPreordertList () {
      order.getPreordertList({order_id_list: this.preorderList}).then(res => {
        let cartList = res.items
        cartList.map(res => {
          if (res.leaveMessage) {
            res.leaveMessage = JSON.parse(res.leaveMessage)
          }
          if (res.specParamList) {
            res.specParamList = JSON.parse(res.specParamList)
          }
        })
        this.cartGoodsList = cartList
      })
    },
    getNowBuyGoods () {
      api.getNowBuyGoods({nowBuyGoods: this.nowBuyGoods}).then(res => {
        let cartList = res.items
        this.cartGoodsList = cartList
      })
    },
    getFastList () {
      api.getFastList(this.fastList).then(res => {
        let cartList = res.items
        cartList.map(res => {
          if (res.leaveMessage) {
            res.leaveMessage = JSON.parse(res.leaveMessage)
          }
          if (res.specParamList) {
            res.specParamList = JSON.parse(res.specParamList)
          }
        })
        this.cartGoodsList = cartList
      })
    },
    orderSubmit (type) {
      if (!this.addressId && this.current_user.MAccountRole !== 3) {
        this.$message.error('请选择收货人信息')
        return
      }
      var orderMsg = {
        cartLists: this.buyGoods,
        preorderList: this.preorderList,
        nowBuyGoods: this.nowBuyGoods,
        fastList: this.fastList,
        addressId: this.addressId,
        remark: this.remark,
        order_source: 0, // 订单来源 0会员，1系统
        pay_order: type === 1 ? 1 : 0
      }
      order.orderSubmit(orderMsg).then(res => {
        if (res.code === 20000) {
          localStorage.removeItem('preorderList')
          localStorage.removeItem('cart_checkList')
          localStorage.removeItem('nowBuy_goods')
          localStorage.removeItem('fastList')
          localStorage.removeItem('payOrder_id')
          if (type === 1) {
            localStorage.setItem('payOrder_id', res.items.order_id)
            this.$router.push({path: '/ToPay'})
          } else {
            this.$router.push({path: '/MyOrder'})
          }
        }
      })
    },
    handleDownloadss () {
      // const { exportExcel } from exports
      const column = [
        {
          title: '维修内容',
          key: 'title',
          type: 'text'
        },
        {
          title: '维修图',
          key: 'fximage',
          type: 'image',
          width: 100,
          height: 100
        },
        {
          title: '订单创建时间',
          key: 'add_time',
          type: 'text'
        }
      ]
      const data = [
        {
          title: 'xiao111',
          fximage: 'http://serv.nmzp.com/uploads/1/image/20220314/347a47ff15bbc27915b51df7a370be5f.jpg',
          add_time: 1601887522
        },
        {
          title: 'xiao222',
          fximage: 'http://serv.nmzp.com/uploads/1/image/20220314/6b8f617276da31d21b56a6f2d30ac024.jpg',
          add_time: 1601887522
        }
      ]
      export2Excel(column, data, '测试文件')
      const app = document.querySelector('#app')
      console.log(app, 'app')
      // app.onclick = function () {
      // this.exportTo2Excel(tHeader, tbody, '测试数据')
      // }
    },
    handleDownloads () {
      if (this.cartGoodsList && this.cartGoodsList.length > 0) {
        this.cartGoodsList.map(res => {
          if (res.specParamList) {
            let specParamList = []
            res.specParamList.map(res => {
              specParamList.push([res.param_name + ':' + res.option_value])
            })
            res.newparamList = specParamList.join(',')
          } else {
            res.newparamList = '-'
          }
          if (res.leaveMessage) {
            let leaveMessage = []
            res.leaveMessage.map(res => {
              leaveMessage.push([res.name + ':' + res.value])
            })
            res.newleaMessage = leaveMessage.join(',')
          } else {
            res.newleaMessage = '-'
          }
          if (res.tax_price === '0.00' || !res.tax_price) {
            res.tax_price = '询价'
            res.totalPrice = '询价'
          } else {
            res.totalPrice = (res.number * res.tax_price).toFixed(2)
          }
          if (!res.plant_sku) {
            res.plant_sku = res.sku
          }
          if (res.imgpath) {
            res.imgpath = res.imgpath.split(',')[0]
          }
          if (!res.premember_name) {
            res.premember_name = '-'
          }
        })
        if (this.downloadLoading) {
          return
        }
        this.downloadLoading = true
        // const title = ['', '', '志鹏供应链']
        // const header = ['代码', '名称', '规格', '价格', '数量', '单位', '小计', '备注']
        const header = [
          {
            title: '图片',
            key: 'imgpath',
            type: 'image',
            width: 100,
            height: 100
          },
          {
            title: '代码',
            key: 'plant_sku',
            type: 'text'
          },
          {
            title: '名称',
            key: 'title',
            type: 'text'
          },
          {
            title: '规格',
            key: 'newparamList',
            type: 'text'
          },
          {
            title: '价格',
            key: 'tax_price',
            type: 'text'
          },
          {
            title: '数量',
            key: 'number',
            type: 'text'
          },
          {
            title: '单位',
            key: 'units',
            type: 'text'
          },
          {
            title: '小计',
            key: 'totalPrice',
            type: 'text'
          },
          {
            title: '备注',
            key: 'newleaMessage',
            type: 'text'
          },
          {
            title: '申购人',
            key: 'premember_name',
            type: 'text'
          }
        ]
        const list = this.cartGoodsList
        const excelName = '志鹏供应链' + this.timeFormate(new Date())
        const colsTitle = '志鹏供应链(内蒙古)有限公司'
        export2Excel(header, list, excelName, colsTitle)
        this.downloadLoading = false
      } else {
        this.$message({
          message: '请选择至少一项',
          type: 'warning'
        })
      }
    },
    handleDownload () {
      if (this.cartGoodsList) {
        this.cartGoodsList.map(res => {
          if (res.specParamList) {
            let specParamList = []
            res.specParamList.map(res => {
              specParamList.push([res.param_name + ':' + res.option_value])
            })
            res.newparamList = specParamList.join(',')
          } else {
            res.newparamList = '-'
          }
          if (res.leaveMessage) {
            let leaveMessage = []
            res.leaveMessage.map(res => {
              leaveMessage.push([res.name + ':' + res.value])
            })
            res.newleaMessage = leaveMessage.join(',')
          } else {
            res.newleaMessage = '-'
          }
          if (res.tax_price === '0.00' || !res.tax_price) {
            res.tax_price = '询价'
            res.totalPrice = '询价'
          } else {
            res.totalPrice = (res.number * res.tax_price).toFixed(2)
          }
          if (!res.plant_sku) {
            res.plant_sku = res.sku
          }
        })
        if (this.downloadLoading) {
          return
        }
        this.downloadLoading = true
        import('@/vendor/Export2Excel').then(excel => {
          const title = ['', '', '志鹏供应链']
          const header = ['代码', '名称', '规格', '价格', '数量', '单位', '小计', '备注']
          const filterVal = ['imgpath', 'plant_sku', 'title', 'newparamList', 'tax_price', 'number', 'units', 'totalPrice', 'newleaMessage']
          const merges = ['C1:F1', 'G1:H1'] // 合并单元格
          const list = this.cartGoodsList
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excela({
            title,
            header,
            filterVal,
            merges,
            data,
            filename: '志鹏供应链' + this.timeFormate(new Date()),
            autoWidth: true,
            bookType: 'xlsx'
          })
          this.downloadLoading = false
        })
      } else {
        this.$message({
          message: '请选择至少一项',
          type: 'warning'
        })
      }
    },
    formatJson (filterVal, jsonData) {
      // return jsonData.map(v => filterVal.map(j => v[j]))
      return jsonData.map(v => filterVal.map(j => {
        // if (j === 'title') {
        //   console.info(123)
        //   const date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(v[j])
        //   return date
        // }

        if (j === 'title') {
          if (v[j]) {
            v[j].replace(/\n/g, '\r\n')
            return v[j].replace(/\n/g, String.valueOf('char(10)'))
          }
          return null
        }
        return v[j]
      }))
    },
    timeFormate (timeStamp) {
      let year = new Date(timeStamp).getFullYear()
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
      let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
      // let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
      // let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
      // let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds()
      return year + '年' + month + '月' + date + '日'
    },
    openAddress (name) {
      this.openType = name
    },
    changeInvoice (e) {
      this.invoice = e
    },
    goPrint () {
      print({
        printable: 'printCons',
        type: 'html',
        // properties: [
        //    { field: 'name', displayName: '姓名', columnSize:`50%`},
        //    { field: 'sex', displayName: '性别',columnSize:`50%`},
        // ],
        // header: `<p class="custom-p"> 名单 </p>`,logs
        // style: '#printCons {width: 600px;} .no-print{width: 0px} .itemText1 { width: 200px } .itemText2 { width: 200px } .itemText3 { width: 200px } .itemText4 { width: 200px }',
        // gridHeaderStyle:'font-size:12px; padding:3px; border:1px solid; font-weight: 100; text-align:left;',
        // gridStyle:'font-size:12px; padding:3px; border:1px solid; text-align:left;',
        // repeatTableHeader: true,
        // scanStyles:true,
        targetStyles: ['*'], // 这样设置继承了页面要打印元素原有的css属性
        ignoreElements: ['no-print'] // 传入要打印的div中的子元素id，使其不打印
      })
    },
    // 发票信息
    showDialogs (e, row) {
      if (e === 1) {
        this.dialogFormVisibles = true
        if (!row) { row = {} }
        this.invoiceForm = Object.assign({}, row)
      } else if (e === 2) {
        this.dialogFormVisibless = true
        if (!row) { row = {} }
        this.invoiceForms = Object.assign({}, row)
      } else if (e === 3) {
        this.dialogFormVisiblesss = true
        if (!row) { row = {} }
        this.addressForms = Object.assign({}, row)
      }
    },
    saveAddresss (row) {
      this.dialogFormVisibles = false
      this.dialogFormVisibless = false
      this.dialogFormVisiblesss = false
    },
    onChangeProvinces (data) {
      this.addressForms.province = data.value
    },
    onChangeCitys (data) {
      this.addressForms.city = data.value
    },
    onChangeAreas (data) {
      this.addressForms.district = data.value
    },
    handleChange (val) {
      if (val) {
        if (!this.addressId) {
          this.checked = false
          this.$message.error('请选择收货人信息')
          return false
        } else {
          this.addressList.map(res => {
            if (res.id === this.addressId) {
              this.addressForms = {
                payee: res.name,
                tel: res.tel,
                province: res.province,
                city: res.city,
                district: res.district,
                address_detail: res.address_detail
              }
            }
          })
        }
      } else {
        this.addressForms = {
          id: null,
          payee: '',
          tel: '',
          province: '',
          city: '',
          district: '',
          address_detail: '',
          postalcode: '',
          telephone: '',
          addressalias: ''
        }
      }
    }
    // 发票信息
  }
}
</script>
<style scoped>
  .cght_tjddullis{
    transition: height 1s ease;
    overflow: hidden;
    box-sizing: border-box;
  }
  .cght_tjddullis3 {
    clear: inherit;
  }
  .cght_tjddtjbzinl{
    border: 0;
  }
  .cght_tjddtjbzin{
    height: 50px;
  }
  .order_title{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .cght_tjddqrxxr2 .cght_gwcdtop3b{
    width: 100%;
    height: 60px;
    padding: 0px;
  }
  .cght_tjddqrxxr2{
    width: 435px;
  }
  .cght_tjddqrxxr{
    background: #fbfdff;
  }
  .leaveMessage{
    font-weight: 500;
  }
  .cght_tjddqrxxr1{
    border: 0;
  }
  .cght_tjddulliskz span{
    display:block;
  }
  .cght_tjddqrxxr5{
    float: right;
    text-align: center;
  }
  .el-icon-place{
    font-size: 15px;
    color: #07357b;
  }
  .el-checkbox {
    font-size: 12px;
    padding-left: 10px;
  }
  .cght_tjddfpxxbzzs {
    width: 182px;
    text-align: center;
    display: block;
    background: #409EFF;
    color: #fff;
    font-size: 14px;
    font-family: "\5B8B\4F53";
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/cart/confirmOrder.vue